<mat-accordion>
    <!-- #enddocregion basic-panel -->
    <mat-expansion-panel [expanded]="panelOpenState === true" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{Question.title}}
            </mat-panel-title>
            <mat-panel-description *ngIf="Question.result != ''">
                {{response}}
            </mat-panel-description>
            <div class="valid" *ngIf="show">Répondu</div>
            <div class="invalid" *ngIf="!show">En cours</div>
        </mat-expansion-panel-header>
        <mat-selection-list #choices [multiple]="false" [(ngModel)]="selectedOptions" (ngModelChange)="onNgModelChange(selectedOptions)">
            <mat-list-option *ngFor="let option of sortBy('title')" [value]="option">
                {{option.title}}
            </mat-list-option>
        </mat-selection-list>
    </mat-expansion-panel>
</mat-accordion>



<div *ngIf="questions.length > 0 && show">
    <div *ngFor="let q of questions">
        <app-generic-display [Question]="q" [SurveyBase]="SurveyBase"></app-generic-display>
    </div>
</div>